/* StepNav.jsx — TASK 5 wizard 8-step header */
import { Check, Lock } from "lucide-react";

export default function StepNav({ steps, currentIdx, onJump }) {
  return (
    <nav
      data-testid="prev-auto-step-nav"
      className="overflow-x-auto -mx-4 px-4 pb-2 mb-6"
    >
      <ol className="flex items-center gap-2 min-w-max">
        {steps.map((s, i) => {
          const done = i < currentIdx;
          const active = i === currentIdx;
          const locked = i > currentIdx;
          return (
            <li key={s.id} className="flex items-center gap-2">
              <button
                type="button"
                disabled={locked}
                onClick={() => !locked && onJump(i)}
                data-testid={`step-nav-${s.id}`}
                className={[
                  "flex items-center gap-1.5 px-2.5 py-1.5 rounded-full text-xs sm:text-sm transition-all",
                  active && "bg-[#163321] text-white shadow-md",
                  done && "bg-emerald-50 text-emerald-800 hover:bg-emerald-100",
                  locked && "bg-slate-100 text-slate-400 cursor-not-allowed",
                  !active && !done && !locked && "bg-slate-100 text-slate-600",
                ].filter(Boolean).join(" ")}
              >
                <span className="inline-flex w-5 h-5 items-center justify-center rounded-full bg-white/20">
                  {done ? <Check className="w-3 h-3" /> :
                   locked ? <Lock className="w-3 h-3" /> : (i + 1)}
                </span>
                <span className="font-medium whitespace-nowrap">{s.label}</span>
              </button>
              {i < steps.length - 1 && (
                <span className="text-slate-300 select-none">→</span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
